module.exports = __webpack_public_path__ + "./kuan-illustration_36b89469620485e8574e2cbd7d9cf5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/kuan-illustration.png
// module id = 424
// module chunks = 0